import React, { useState, useCallback, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import M from "materialize-css/dist/js/materialize.min.js";
import "./Navbar.css";
import LogoImage from "./YEP white.png";
import { AppBar, Toolbar, Typography, Box, Button, Menu, MenuItem, Badge, IconButton } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MenuIcon from "@mui/icons-material/Menu";
import EventsModal from "./common/eventsModal";
import { useAuth, useFirebaseData } from "../hooks";
import { firebaseQueryOperators } from "../utils/queryBuilder";
import { collectionNames } from "../constants/firebase";
import { isSameDayAndMonth } from "../utils";
import moment from "moment/moment";

// const NavBar = () => {
//   const { user } = useAuth();
//   const [open, setOpen] = useState(false);

//   const { data, isFetching } = useFirebaseData(
//     collectionNames.STAFF,
//     ...(user?.isAdmin
//       ? []
//       : [
//           {
//             property: "user",
//             operator: firebaseQueryOperators.EQUAL_TO,
//             value: user?.email,
//           },
//         ])
//   );
//   const events =
//     data && data.length > 0
//       ? data.filter(
//           ({ dob, anniversary }) =>
//             (dob &&
//               isSameDayAndMonth(
//                 moment(dob?.toDate()),
//                 moment(new Date()).add(1, "days")
//               )) ||
//             (anniversary &&
//               isSameDayAndMonth(
//                 moment(anniversary?.toDate()),
//                 moment(new Date()).add(1, "days")
//               ))
//         )
//       : [];

//   return (
//     <div className="navbar-fixed">
//       <nav className="blue-grey darken-4">
//         <div className="container nav-wrapper">
//           <Link to="#">
//             <span className="brand-logo">YEP CRM</span>
//           </Link>
//           {user !== null && (
//             <Link to="/HomePage">
//               <span className="left">
//                 <img
//                   src={LogoImage}
//                   style={{
//                     width: 100,
//                     height: 70,
//                     marginBottom: 3,
//                     marginRight: 30,
//                   }}
//                   alt=""
//                 />
//                 {/* <i className="material-icons home">home</i> */}
//               </span>
//             </Link>
//           )}
//           {user === null && (
//             <Link to="#">
//               <span className="left">
//                 <img
//                   src={LogoImage}
//                   style={{
//                     width: 100,
//                     height: 70,
//                     marginBottom: 3,
//                     marginRight: 30,
//                   }}
//                   alt=""
//                 />
//                 {/* <i className="material-icons home">home</i> */}
//               </span>
//             </Link>
//           )}
//           {user && (
//             <IconButton
//               aria-label="delete"
//               className="right"
//               sx={{ color: "#fff" }}
//               onClick={() => setOpen(true)}
//               size="large"
//             >
//               {events && events.length > 0 ? (
//                 <NotificationsActiveIcon />
//               ) : (
//                 <NotificationsIcon />
//               )}
//             </IconButton>
//           )}
//           {open && (
//             <EventsModal
//               open={open}
//               handleClose={() => setOpen(false)}
//               events={events}
//               isLoading={isFetching}
//             />
//           )}
//           {user !== null ? (
//             <ul className="right">
//               <li>
//                 <button
//                   className="btn white black-text waves-effect waves-teal"
//                   onClick={() => {
//                     M.toast({
//                       html: `Logout successfully`,
//                       classes: "green darken-1 rounded",
//                     });
//                     auth.signOut();
//                   }}
//                 >
//                   Logout
//                 </button>
//               </li>
//             </ul>
//           ) : null}
//         </div>
//       </nav>
//     </div>
//   );
// };

// export default NavBar;


const NavBar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const { data, isFetching } = useFirebaseData(
    collectionNames.STAFF,
    user?.isAdmin
      ? []
      : [
          {
            property: "user",
            operator: firebaseQueryOperators.EQUAL_TO,
            value: user?.email,
          },
        ]
  );

  const events = useMemo(() => {
    if (!data || data.length === 0) return [];
    return data.filter(
      ({ dob, anniversary }) =>
        (dob &&
          isSameDayAndMonth(
            moment(dob?.toDate()),
            moment(new Date()).add(1, "days")
          )) ||
        (anniversary &&
          isSameDayAndMonth(
            moment(anniversary?.toDate()),
            moment(new Date()).add(1, "days")
          ))
    );
  }, [data]);

  const handleMenuOpen = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleLogout = useCallback(() => {
    handleMenuClose();
    M.toast({
      html: `Logout successfully`,
      classes: "green darken-1 rounded",
    });
    auth.signOut();
    navigate("/");
  }, [handleMenuClose, navigate]);

  const renderMobileMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleLogout}>Logout</MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" sx={{ bgcolor: "#263238" }}>
        <Toolbar>
          <Link
            to={user ? "/HomePage" : "/"}
            style={{ display: "flex", alignItems: "center", textDecoration: 'none', color: 'inherit' }}
          >
            <img
              src={LogoImage}
              style={{ height: 50, width: "auto", marginRight: '16px' }}
              alt="YEP Logo"
            />
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ display: { xs: "none", sm: "block" } }}
            >
              Yep CRM
            </Typography>
          </Link>

          <Box sx={{ flexGrow: 1 }} />

          {user && (
            <>
              {/* Desktop Icons */}
              <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
                <IconButton
                  size="large"
                  aria-label={`show ${events.length} new notifications`}
                  color="inherit"
                  onClick={() => setOpen(true)}
                >
                  <Badge badgeContent={events.length} color="error">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                <Button color="inherit" onClick={handleLogout}>
                  Logout
                </Button>
              </Box>

              {/* Mobile Icons */}
              <Box sx={{ display: { xs: "flex", md: "none" } }}>
                <IconButton
                  size="large"
                  aria-label={`show ${events.length} new notifications`}
                  color="inherit"
                  onClick={() => setOpen(true)}
                >
                  <Badge badgeContent={events.length} color="error">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                <IconButton
                  size="large"
                  edge="end"
                  aria-label="account of current user"
                  aria-haspopup="true"
                  onClick={handleMenuOpen}
                  color="inherit"
                >
                  <MenuIcon />
                </IconButton>
              </Box>
            </>
          )}
        </Toolbar>
      </AppBar>
      {user && renderMobileMenu}
      {open && (
        <EventsModal
          open={open}
          handleClose={() => setOpen(false)}
          events={events}
          isLoading={isFetching}
        />
      )}
      {/* Spacer for fixed AppBar */}
      <Toolbar />
    </Box>
  );
};

export default React.memo(NavBar);
